<div class="my-4 mx-5">
    <div class="wrapper mb-5">
        <div class="row align-items-center m-0 mb-5" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Aportes e Pagamentos</span>
        </div>
            <app-depositos-create></app-depositos-create>


        <div class="component-box container-fluid">
            <div class="container-fluid pt-4">
                <app-depositos-pagamentos-list></app-depositos-pagamentos-list>
            </div>
        </div>
    </div>
</div>
